import { React, useState, useEffect } from 'react'
import "../../styles/contadorVisitas.css"

import firebaseApp from "../firebase/Credenciales"
import { getFirestore, collection, getDocs } from "firebase/firestore";

const firestore = getFirestore(firebaseApp);
const usuariosRef = collection(firestore, 'usuarios');

function ContadorVisitas() { 

  const [cantidadUsuarios, setCantidadUsuarios] = useState(0);

  useEffect(() => {
    // Función asincrónica para obtener la cantidad de documentos en la colección 'usuarios'
    const obtenerCantidadUsuarios = async () => {
      try {
        const querySnapshot = await getDocs(usuariosRef);
        const cantidad = querySnapshot.size;
        setCantidadUsuarios(cantidad);
      } catch (error) {
        console.error("Error al obtener la cantidad de usuarios:", error);
      }
    };

    // Llama a la función para obtener la cantidad de usuarios cuando el componente se monta
    obtenerCantidadUsuarios();
  }, []); // El array vacío como segundo argumento significa que useEffect se ejecuta solo una vez al montarse el componente

  return (
    <i className="fa-regular fa-eye">{cantidadUsuarios}</i>
  )
}

export default ContadorVisitas
